var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-wrapper"},[_c('h1',[_vm._v("Demo QR Code")]),_c('div',{staticStyle:{"flex":"0 0 30vh","width":"30vh","margin":"0 auto"}},[_c('qrcode-stream',{on:{"decode":_vm.onDecode}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }